import { graphql } from "../generated"

export const getActiveAnnouncementsQuery = graphql(`
  query GetActiveAnnouncements {
    getActiveAnnouncements {
      id
      title
      message
      publishDate
      endDate
      status
    }
  }
`)
